import { useEffect } from "react";
import { Button, Form, Input, Modal } from "antd";

export default function KnowledgeModal({ open, saving, record, onCancel, onSubmit }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      form.resetFields();
      return;
    }
    form.setFieldsValue({
      title: record?.title || "",
      content: record?.content || "",
    });
  }, [form, open, record]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit?.(values);
    } catch (error) {}
  };

  return (
    <Modal
      title={record?.id ? "编辑知识" : "新增知识"}
      open={open}
      centered
      onCancel={onCancel}
      width={720}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="submit" type="primary" loading={saving} onClick={handleOk}>
          保存
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="标题" name="title" rules={[{ required: true, message: "请输入标题" }]}>
          <Input placeholder="请输入标题" maxLength={100} />
        </Form.Item>
        <Form.Item label="内容" name="content" rules={[{ required: true, message: "请输入内容" }]}>
          <Input.TextArea rows={12} placeholder="请输入知识内容" maxLength={10000} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
